import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { useAdminContext } from '../../../../context/adminContext';
import { createOrUpdateBusOperatorApi, getAllBusOperatorPGApi, getAllBusRoutesPGApi, getAllBusTicketPGApi,  removeBusOperatorApi,  removeBusRouteApi,  updateBusTicketStatusApi,} from '../../../../utils/ApiEndpointFunctions';
import Header from '../../../common/Header';
import { busOperatorInitialValue, busOperatorValidationSchema } from "../../../common/Validation"
import Pagination from '../../../common/Pagination';
import Spinwheel from '../../../common/Spinwheel';
import { ImageUrl } from '../../../../utils/BaseUrl';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import UpdateTicketStatus from '../../../common/updateTicketStatus';
import { toast } from 'react-hot-toast';
import { debounce } from 'lodash';
import moment from 'moment';
import RemoveModal from '../../../common/RemoveModal';
import BusOperatorModal from './BusOperatorModal';

function BusOperator() {
  const navigate = useNavigate()
  const [tableSpin, setTableSpin] = useState(true);
  const [busTicket, setBusTicket] = useState([]);
  let [selectedPage, setSelectPage] = useState(0);
  const [page, setPage] = useState(0);
  const busOperatorModalId = "busOperatorModalId"
  const ticketStatusModalId = "ticketStatusModalId"
  const removeBusOperatorModalId = "removeBusOperatorModalId"
  const [selectedBusOperator, setSelectedBusOperator] = useState(null)
  const [selectedBusRoute,setSelectedBusRoute] = useState(null)
  const [addLoader, setAddLoader] = useState(false)
  const limit = 10;

  const getAllBusOperator = async (selectedPage, search) => {
    try {
      setTableSpin(false)
      const res = await getAllBusOperatorPGApi(search || "", selectedPage + 1, limit)
      if (res.status === 200) {
        setBusTicket(res.data?.data?.data)
        const totaldata = res.data?.data?.totalData

        setPage(Math.ceil(totaldata / limit));
      }
      setTableSpin(true)
    } catch (error) {
      setTableSpin(true)
    }
  }

  const handlePageClick = (event) => {
    setSelectPage(event.selected);
    getAllBusOperator(event.selected)
  };

  const handleSubmit = async (values) => {
    const payload = {
      ...values,
    }
    if(selectedBusOperator){
      payload._id = selectedBusOperator
    }
    try {
      setAddLoader(true)
      const res = await createOrUpdateBusOperatorApi(payload);
      if (res?.status === 200) {
        toast.success(res.data?.message)
        getAllBusOperator(0)
        setAddLoader(false)
        document.getElementById(busOperatorModalId).click()
        setSelectedBusOperator(null)
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
      setAddLoader(false)
    }
  }


  const formik = useFormik({
    initialValues: busOperatorInitialValue,
    onSubmit: handleSubmit,
    validationSchema: busOperatorValidationSchema,
  })
  const onChange = async (e) => {
    let search = e.target.value;
    getAllBusOperator(0, search)
  };

  const debouncedOnChange = debounce(onChange, 500);


  const handleRemoveBusOperator = async () => {
   try {
     const res = await removeBusOperatorApi(selectedBusOperator);
     if (res?.status === 200) {
       toast.success(res.data?.message)
       getAllBusOperator(0)
       document.getElementById(removeBusOperatorModalId).click()
     }
   } catch (error) {
     toast.error(error?.response?.data?.message);
   }
 }

  useEffect(() => {
    getAllBusOperator(selectedPage)
  }, [])




  return (
    <>
      {/*<Sidebar />*/}
      <div className="main-content vh-100 vh_md-auto overflow-y-a">
        <Header title="Bus ticket" />
        {/* CARDS */}
        <div className="container-fluid">
          <div className="row">
            <nav className="mb-5">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">
                    <i className="fe fe-home"></i> Dashboard
                  </Link>
                </li>
                <Link to="/ticket/bus/tickets" className="breadcrumb-item active" aria-current="page">
                  Bus ticket
                </Link>
                <Link to="/ticket/bus/routes" className="breadcrumb-item active" aria-current="page">
                  Bus routes
                </Link>
               
                <li className="breadcrumb-item active" aria-current="page">
                  Bus operator
                </li>
              </ol>
            </nav>
            <div className="mb-4" style={{ textAlign: "end" }}>
              <div className='d-flex justify-content-end gap-2' style={{ display: "-webkit-inline-box" }}>
                <div className='d-flex gap-2 align-items-center justify-content-center'>
                  <button data-bs-toggle="modal" data-bs-target={`#${busOperatorModalId}`} className='btn-custom w-auto' style={{ cursor: "pointer" }} onClick={() => {formik.resetForm() }}>
                  Add
                  </button>
                  <div className="position-relative">
                    <input
                      className="form-search me-3"
                      type="search"
                      name=""
                      onChange={debouncedOnChange}
                      placeholder="Search"
                    />
                    <img
                      className="users-search"
                      src="/images/Icon feather-search.svg"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <hr />

            <div className="card p-3 table-responsive" >
              <table className="table table-hover table-nowrap card-table">
                <thead>
                  <tr>
                    <th>
                      <span
                        className="list-sort text-muted"
                      >
                        S.No
                      </span>
                    </th>
                    <th>
                      <span
                        className="list-sort text-muted"
                      >
                        Name
                      </span>
                    </th>
                    <th>
                      <span
                        className="list-sort text-muted"
                      >
                        Phone
                      </span>
                    </th>
                    <th>
                      <span
                        className="list-sort text-muted"
                      >
                        Address
                      </span>
                    </th>
                    <th></th>


                  </tr>
                </thead>
                {
                  tableSpin ?
                    <tbody className="list fs-base">
                      {busTicket?.length > 0 ? busTicket?.map((ele, index) => {
                        return (<tr key={index} >
                          <td>{index + 1}</td>
                           <div className='position-relative d-flex'>
                              <div className="avatar avatar-xs align-middle me-2">
                                 <img
                                    className="avatar-img rounded-circle"
                                    src={ele?.image ? ImageUrl + encodeURIComponent(ele?.image) : process.env.PUBLIC_URL + "/images/person-circle.svg"}
                                    alt=""
                                 />
                              </div>
                              <p className='mb-0 capitalize'>{ele?.name?.length > 30 ? <span>
                              {ele?.name?.substr(0, 30)}...
                              <div className="tooltip1 item-name text-reset" ></div>
                              <div className='wrapper'>
                                <div className="tooltip1-text">{ele?.name}</div>
                              </div>
                            </span> :
                              <span>{ele?.name || "-"}</span>}</p>
                              
                           </div>
                           <td className='position-relative'>
                            {ele?.phone || "-"}
                          </td>
                          <td className='position-relative'>
                            {ele?.address?.length > 30 ? <span>
                              {ele?.address?.substr(0, 30)}...
                              <div className="tooltip1 item-name text-reset" ></div>
                              <div className='wrapper'>
                                <div className="tooltip1-text">{ele?.address}</div>
                              </div>
                            </span> :
                              <span>{ele?.address || "-"}</span>}

                          </td>
                  

                          <td className="text-end">
                            {ele?.status?.toLowerCase() != "transferred" &&
                              <div className="dropdown">
                                <span
                                  className="dropdown-ellipses dropdown-toggle"
                                  role="button"
                                  data-bs-toggle="dropdown"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                >
                                  <i className="fe fe-more-vertical" />
                                </span>
                                <div className="dropdown-menu dropdown-menu-end">
                                <div data-bs-toggle="modal" data-bs-target={`#${removeBusOperatorModalId}`} className='dropdown-item' style={{ cursor: "pointer" }} onClick={() => { setSelectedBusOperator(ele?._id) }}>
                                    Remove
                                  </div>
                                  <div data-bs-toggle="modal" data-bs-target={`#${busOperatorModalId}`} className='dropdown-item' style={{ cursor: "pointer" }} onClick={() => { setSelectedBusOperator(ele?._id);formik.setValues(ele) }}>
                                    View / edit
                                  </div>
                                </div>
                              </div>}
                          </td>
                        </tr>
                        )
                      }) : <tr align="center">
                        <td colSpan="9">
                          <h1>
                            Data Not Found
                          </h1>
                        </td>
                      </tr>}
                    </tbody> : (
                      <tbody>
                        <tr align="center">
                          <td colSpan="9">
                            <Spinwheel />
                          </td>
                        </tr>
                      </tbody>
                    )
                }
              </table>
            </div>
            <div className="d-flex justify-content-center">
              {busTicket?.length > 0 ? <Pagination
                clickHandler={handlePageClick}
                page={page}
                selectedPage={selectedPage}
              />
                : null}
            </div>
          </div>
          <BusOperatorModal modalId={busOperatorModalId} formik={formik} addLoader={addLoader} />
          <RemoveModal removeHandler={handleRemoveBusOperator} modalId={removeBusOperatorModalId} message={"Are you sure you want to remove?"} />
        </div>
      </div>
    </>
  )
}

export default BusOperator